if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    // ギフトラッピング（KINUJO製品限定）
    // 「ギフトラッピングを追加する」にチェックが入っていれば、本体と一緒にカートへ入れるラッピングの明細を返す。
    // カートにまだラッピングが1つもなければ1つ目は「1台目」のバリエーション、残りは「2台目以降（半額）」のバリエーション。
    // カートにすでにラッピングがあれば、追加分はすべて「2台目以降（半額）」のバリエーション。
    getGiftWrapItems(mainQuantity) {
      const checkbox = this.form.querySelector('[data-kk-wrap-checkbox]');
      if (!checkbox || !checkbox.checked) return Promise.resolve([]);

      const firstId = Number(checkbox.dataset.firstId);
      const halfId = Number(checkbox.dataset.halfId) || firstId;
      const wrapHandle = checkbox.dataset.wrapHandle;
      if (!firstId) return Promise.resolve([]);

      const buildItems = (existingWrapCount) => {
        const items = [];
        let remaining = mainQuantity;
        if (existingWrapCount === 0) {
          items.push({ id: firstId, quantity: 1 });
          remaining -= 1;
        }
        if (remaining > 0) items.push({ id: halfId, quantity: remaining });
        return items;
      };

      return fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          const existing = (cart.items || [])
            .filter((item) => item.handle === wrapHandle)
            .reduce((count, item) => count + item.quantity, 0);
          return buildItems(existing);
        })
        .catch(() => buildItems(0));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      const mainVariantId = Number(formData.get('id'));
      const mainQuantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);

      this.getGiftWrapItems(mainQuantity)
        .then((wrapItems) => {
          if (wrapItems.length === 0) {
            // ラッピングなし：今までどおりフォームの内容をそのまま送る
            config.body = formData;
          } else {
            // ラッピングあり：本体とラッピングをまとめて1回で送る（JSON形式）
            const mainItem = { id: mainVariantId, quantity: mainQuantity };
            const properties = {};
            formData.forEach((value, key) => {
              const match = key.match(/^properties\[(.+)\]$/);
              if (match) properties[match[1]] = value;
            });
            if (Object.keys(properties).length > 0) mainItem.properties = properties;
            if (formData.get('selling_plan')) mainItem.selling_plan = formData.get('selling_plan');

            const body = { items: [mainItem].concat(wrapItems) };
            if (this.cart) {
              body.sections = this.cart.getSectionsToRender().map((section) => section.id);
              body.sections_url = window.location.pathname;
            }
            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify(body);
          }
          return fetch(`${routes.cart_add_url}`, config);
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // 複数商品をまとめて入れたときは、カート通知に本体の明細を出す
          if (response.items && !response.key) {
            const mainLine = response.items.find((item) => item.variant_id === mainVariantId) || response.items[0];
            if (mainLine) response.key = mainLine.key;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
